import { render, staticRenderFns } from "./Deliverable.vue?vue&type=template&id=5c151b50"
import script from "./Deliverable.vue?vue&type=script&lang=js"
export * from "./Deliverable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports